import type { ApplicationState } from '..';

export const getMessageLoading = ({ message }: ApplicationState) =>
  message?.loading;
export const getMessageOverlay = ({ message }: ApplicationState) =>
  message?.overlay;
export const getMessageText = ({ message }: ApplicationState) => message?.text;
